import React from 'react';

export interface VersionAsset {
  label: string;
  path: string;
}

export interface Version {
  version: string;
  win?: VersionAsset[];
  mac?: VersionAsset[];
  linux?: VersionAsset[];
}

export interface IVersionsContext {
  versions: Version[];
}

const initialState: IVersionsContext = {
  versions: [],
};

export const VersionsContext =
  React.createContext<IVersionsContext>(initialState);
